<template>
    <el-select v-model="receiveAgentId" filterable remote :remote-method="remoteMethod" @change="onChange" :placeholder="placeholder" :clearable="clearable">
        <slot name="el-option"></slot>
        <el-option
            v-for="(item, index) in userList"
            :key="item.value"
            :label="item.label"
            :value="valueLabel ? item.label : item.value">
        </el-option>
    </el-select>
</template>

<script>
    import request from "@/utils/request"
    export default {
        name: "index",
        props: {
            value: [String, Number, Object, Array],
            defaultRequest: { // 是否一开始默认请求一次全部数据 也就是传入key=''
                type: Boolean,
                default: true,
            },
            placeholder: { // 没值时的提示
                type: String,
                default: ''
            },
            defaultId: { // 是否拿到第一个数据作为默认选项(有数据的话) 会触发onChange事件
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            valueLabel: { // 给后端的值是 label
                type: Boolean,
                default: false,
            }
        },
        watch: {
            value: {
                handler (newVal) {
                    this.receiveAgentId = newVal
                },
                immediate: true
            }
        },
        data () {
            return {
                receiveAgentId: '',
                userList: [],
                first: true,
            }
        },
        created () {
            this.defaultRequest && this.remoteMethod()
        },
        methods: {
            remoteMethod(query='') {
                let params = {
                    key: query
                }
                request.get('/manager/agent/findAgentList', { params }).then(({result}) => {
                    this.userList = result.map((item) => ({value: item.agentId, label: item.name + '-' + item.username}));
                    // this.defaultId && this.$emit('input', this.userList.length > 0 ? this.userList[0].value : '')
                    if (this.first && this.defaultId) {
                        this.onChange(this.userList.length > 0 ? this.userList[0].value : '')
                        this.first = false
                    }
                });
            },
            onChange (val) {
                this.$emit('input', val)
                this.$emit('onChange', val)
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selectAgentForm/index.vue